import { LS } from './storage';

let _audioCtx = null;

export const getAudioCtx = () => {
    try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        if (!_audioCtx || _audioCtx.state === 'closed') _audioCtx = new AC();
        return _audioCtx;
    } catch { return null; }
};

export const getSoundVolume = () => LS.getFloat('sound_volume', 0.5);

export const playNotificationSound = (type = 'message') => {
    try {
        const ctx = getAudioCtx();
        if (!ctx) return;
        const play = () => {
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.connect(gain);
            gain.connect(ctx.destination);
            const volume = getSoundVolume();
            if (type === 'mention') {
                osc.type = 'sine';
                osc.frequency.setValueAtTime(1046.50, ctx.currentTime);
                gain.gain.setValueAtTime(0.2 * volume, ctx.currentTime);
                gain.gain.exponentialRampToValueAtTime(0.00001, ctx.currentTime + 1.5);
                osc.start(); osc.stop(ctx.currentTime + 1.5);
            } else {
                osc.type = 'sine';
                osc.frequency.setValueAtTime(523.25, ctx.currentTime);
                gain.gain.setValueAtTime(0.1 * volume, ctx.currentTime);
                gain.gain.exponentialRampToValueAtTime(0.00001, ctx.currentTime + 0.3);
                osc.start(); osc.stop(ctx.currentTime + 0.3);
            }
        };
        if (ctx.state === 'suspended') { ctx.resume().then(play).catch(e => console.error("Audio resume failed", e)); }
        else { play(); }
    } catch (e) { console.error("Audio play failed", e); }
};
